import { useDispatch, useSelector } from 'react-redux'

import { Box } from '@material-ui/core'

import { EditApplications, EditDescription, EditTags, EditTitle } from 'UI/Routes/main/common'

import { QGCallToActionButton } from './QGCallToActionButton'
import { EditCommentsPermission } from './EditCommentsPermission'
import { ShareLink, SpacedGroup, Label } from 'UI/Components'

import { PlaybookType, QuickGuidePlaybookType } from 'app/types'
import {
    disableShortcuts,
    enableShortcuts,
    setQuickGuiddeApplications,
    setQuickGuiddeComments,
    setQuickGuiddeDescription,
    setQuickGuiddeTags,
    setQuickGuiddeTitle
} from 'ducks/actions'
import { uiId } from 'modules'

type Props = {
    revalidate: (data?: QuickGuidePlaybookType, params?: { revalidate?: boolean }) => void
    playbook: PlaybookType & { version: number }
}

export const QGMetadata = ({ revalidate, playbook }: Props) => {
    const dispatch = useDispatch()

    const { id, mode } = playbook

    const { qgTitle, qgDescription, qgApplications, qgNewTags, commentsStatus } = useSelector(
        state => state.qgMetadata
    )

    const handleFocus = () => dispatch(disableShortcuts())
    const handleBlur = () => dispatch(enableShortcuts())

    return (
        <Box p={2}>
            <SpacedGroup flexDirection="column">
                <EditTitle
                    playbookId={id}
                    value={qgTitle}
                    showCharCount={true}
                    multiline={true}
                    maxLength={150}
                    mode={mode}
                    onSave={value => dispatch(setQuickGuiddeTitle(value))}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                />

                <EditDescription
                    playbookId={id}
                    value={qgDescription}
                    disabled={false}
                    showCharCount={true}
                    multiline={true}
                    maxLength={500}
                    mode={mode}
                    onSave={value => dispatch(setQuickGuiddeDescription(value))}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                />

                <Box mb={2}>
                    <EditCommentsPermission
                        playbookId={id}
                        commentsStatus={commentsStatus}
                        onSave={value => dispatch(setQuickGuiddeComments(value))}
                    />
                </Box>

                <QGCallToActionButton
                    playbook={playbook}
                    revalidate={data => revalidate(data, { revalidate: false })}
                />

                <Box>
                    <Label label="Visibility" />
                    <Box my={-1} mx={-2} mb={-2} id={uiId('playbook-visibility')}>
                        <ShareLink
                            playbook={playbook}
                            hideCopyLink={true}
                            hideLinkTemplates={true}
                        />
                    </Box>
                </Box>

                <EditTags
                    playbookId={id}
                    values={qgNewTags}
                    width="100%"
                    mode={mode}
                    onChange={(newTags, toDeletedTags) => {
                        dispatch(
                            setQuickGuiddeTags({
                                qgNewTags: newTags,
                                qgDeletedTags: toDeletedTags
                            })
                        )
                    }}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                />

                <EditApplications
                    playbook={playbook}
                    qgApplications={qgApplications}
                    onChange={(newApps, deletedApp) => {
                        dispatch(
                            setQuickGuiddeApplications({
                                qgApplications: newApps,
                                qgDeletedApps: deletedApp
                            })
                        )
                    }}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                />
            </SpacedGroup>
        </Box>
    )
}
